import React from 'react';
import { GlobeIcon } from 'lucide-react';
export function CountrySelector({
  countries,
  onSelectCountry
}) {
  return <div className="p-6" data-id="element-8">
      <h2 className="text-2xl font-semibold mb-6 text-gray-800" data-id="element-9">
        Select a Country
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-10">
        {countries.map(country => <button key={country.id} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow flex items-center gap-4 text-left" onClick={() => onSelectCountry(country)} data-id="element-11">
            <div className="bg-blue-50 p-3 rounded-full" data-id="element-12">
              <GlobeIcon className="h-6 w-6 text-blue-500" data-id="element-13" />
            </div>
            <div data-id="element-14">
              <h3 className="font-semibold text-lg text-gray-800" data-id="element-15">
                {country.name}
              </h3>
              <p className="text-gray-500 text-sm" data-id="element-16">
                {country.landmarks.length} landmarks
              </p>
            </div>
          </button>)}
      </div>
    </div>;
}